module.exports = __webpack_public_path__ + "static/gallery13-e06ff56916cb6cceea71d4d0e1df9449.jpg";